// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiSelect-root {
  width: 100%;
}


body {
  background: #b80000;
  background-size: 100%;
}

.login-body {
  background-color: #b80000;
}

.logo-left {
  border-right: 2px solid #b80000;
}

.form-signin .btn-login {
  color: #fff !important;
  background-image: linear-gradient(315deg, #b80000 0%, #000000 74%);
}

.btn {
  border: 1px solid #b80000;
}

.btnRefresh {
  background-color: black;
  border: 0;
  padding: 7px 10px;
  color: #FFF;
  float: right;
}

.log_img {
  width: 140px;
  display: table;
  margin: auto;
}
.input-group-addon{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 34px;
}



/*====Login CSS===*/

.login_c_field{display:flex;align-items:center}
.login_c_field div{margin:3px;}

.loginBox {
  background: #ffffff;
  margin: 40px 10px 40px;
  position: relative;
  background: #fff;
  border-radius: 20px;
}

.logo-left {
  border-right: 3px solid #b80000;
  height: 552px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-new-tb {
  text-align: center;
}

.logo-new-tb img {
  width: 70%!important;
  text-align: center;
}

.logo-form-right .Login-title h1 {
  display: inline-block;
  color: #000!important;
  font-size: 32px;
  margin-bottom: 25px;
}

.logo-form-right {
  padding: 30px 90px 0px 90px;
  height: 552px;
}

.login-part-inner h4 {
  font-weight: bold;
  font-size: 12px;
  color: #666;
}

.login-part-inner .form-control {
  display: block;
  width: 100%;
  height: 38px;
  padding: 0.375rem 0.75rem!important;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5!important;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.input-group-addon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.input-group .form-control {
  position: relative;
  z-index: 2;
  float: left;
  width: 80%;
  margin-bottom: 0;
}
.my_input {
  position: relative;
  display: flex;
  height: 38px;
  margin-bottom: 16px;
}

.footer {
  color: white;
  width: 100%;
  font-size: 11px;
  bottom: 5px;
  text-align: center;
}

.logo-newtop img {
  width: auto;
  height: 54px;
}

.sidebar-toggle-box .tooltips {
  color: #000!important;
}

.badge-warning {
  color: #fff;
  background-color: var( --primarycolor)!important;
  border-radius: 5px;
  padding: 5px;
}

.badge {
  border-radius: 5px!important;
  font-weight: 400!important;
}

.badge-success {
  color: #fff;
  background-color: #28a745 !important;
  padding: 10px 20px!important;
}

span.badge.badge-xs.badge-success {
  padding: 9px 20px;
  /* justify-content: revert; */
}

.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active,
.open .dropdown-toggle.btn-info {
  background-color: var(--primarycolor);
  border-color: var(--btnbordercolor);
  color: #FFFFFF;
}

.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.open .dropdown-toggle.btn-success {
  background-color: var(--primarycolor);
  border-color: var( --btnbordercolor);
  color: #FFFFFF;
}

.bg-success {
  background-color: var( --)!important;
}

.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active,
.open .dropdown-toggle.btn-danger {
  background-color: #ff9700;
  border-color: #ff9700;
  color: #FFFFFF;
}

a.btn-xs {
  margin: 2px 2px;
}

.btn-xs {
  padding: 3px 7px;
  font-size: 12px!important;
  font-weight: 400;
  text-align: center;
  margin: 2px;
}
.btn-xs:hover{
  background: var(--btn-hover-color) !important;
}
.adv-table .dataTables_length select{
      padding: 5px 0 !important;
}

.ban-head-new {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var( --secondary-color);
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-group-lg>.btn, .btn-lg {
  padding: 10px 16px;
  margin-top: 20px;
  font-size: 18px;
  line-height: 1.3333333;
  border-radius: 6px;
}

.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
.col-lg-12 {
  padding: 5px 15px;
}

.btnRefresh {
  width: 40px;
  height: 40px;
  color: #fff !important;
  background-image: linear-gradient(315deg, #b80000 0%, #000000 74%);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.btnRefresh:hover {
  background-color: #0056b3;
}

.btnRefresh:before {
  content: '\\21BB'; /* Unicode for refresh icon */
}`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;;AAGA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;;;AAIA,mBAAmB;;AAEnB,eAAe,YAAY,CAAC,kBAAkB;AAC9C,mBAAmB,UAAU,CAAC;;AAE9B;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAEhB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EAIX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AAXpB;AAaA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gDAAgD;EAChD,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;;;;EAKE,qCAAqC;EACrC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;;;;EAKE,qCAAqC;EACrC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,6CAA6C;AAC/C;AACA;MACM,yBAAyB;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kEAAkE;EAClE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB,EAAE,6BAA6B;AACjD","sourcesContent":[".MuiSelect-root {\n  width: 100%;\n}\n\n\nbody {\n  background: #b80000;\n  background-size: 100%;\n}\n\n.login-body {\n  background-color: #b80000;\n}\n\n.logo-left {\n  border-right: 2px solid #b80000;\n}\n\n.form-signin .btn-login {\n  color: #fff !important;\n  background-image: linear-gradient(315deg, #b80000 0%, #000000 74%);\n}\n\n.btn {\n  border: 1px solid #b80000;\n}\n\n.btnRefresh {\n  background-color: black;\n  border: 0;\n  padding: 7px 10px;\n  color: #FFF;\n  float: right;\n}\n\n.log_img {\n  width: 140px;\n  display: table;\n  margin: auto;\n}\n.input-group-addon{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 34px;\n}\n\n\n\n/*====Login CSS===*/\n\n.login_c_field{display:flex;align-items:center}\n.login_c_field div{margin:3px;}\n\n.loginBox {\n  background: #ffffff;\n  margin: 40px 10px 40px;\n  position: relative;\n  background: #fff;\n  border-radius: 10px;\n  border-radius: 20px;\n}\n\n.logo-left {\n  border-right: 3px solid #b80000;\n  height: 552px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logo-new-tb {\n  text-align: center;\n}\n\n.logo-new-tb img {\n  width: 70%!important;\n  text-align: center;\n}\n\n.logo-form-right .Login-title h1 {\n  display: inline-block;\n  color: #000!important;\n  font-size: 32px;\n  margin-bottom: 25px;\n}\n\n.logo-form-right {\n  padding: 30px 90px 0px 90px;\n  height: 552px;\n}\n\n.login-part-inner h4 {\n  font-weight: bold;\n  font-size: 12px;\n  color: #666;\n}\n\n.login-part-inner .form-control {\n  display: block;\n  width: 100%;\n  height: 38px;\n  padding: 0.375rem 0.75rem!important;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5!important;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n}\n\n.input-group-addon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 34px;\n}\n\n.input-group-addon {\n  padding: 6px 12px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1;\n  color: #555;\n  text-align: center;\n  background-color: #eee;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.input-group .form-control {\n  position: relative;\n  z-index: 2;\n  float: left;\n  width: 80%;\n  margin-bottom: 0;\n}\n.my_input {\n  position: relative;\n  display: flex;\n  height: 38px;\n  margin-bottom: 16px;\n}\n\n.footer {\n  color: white;\n  width: 100%;\n  font-size: 11px;\n  bottom: 5px;\n  text-align: center;\n}\n\n.logo-newtop img {\n  width: auto;\n  height: 54px;\n}\n\n.sidebar-toggle-box .tooltips {\n  color: #000!important;\n}\n\n.badge-warning {\n  color: #fff;\n  background-color: var( --primarycolor)!important;\n  border-radius: 5px;\n  padding: 5px;\n}\n\n.badge {\n  border-radius: 5px!important;\n  font-weight: 400!important;\n}\n\n.badge-success {\n  color: #fff;\n  background-color: #28a745 !important;\n  padding: 10px 20px!important;\n}\n\nspan.badge.badge-xs.badge-success {\n  padding: 9px 20px;\n  /* justify-content: revert; */\n}\n\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active,\n.open .dropdown-toggle.btn-info {\n  background-color: var(--primarycolor);\n  border-color: var(--btnbordercolor);\n  color: #FFFFFF;\n}\n\n.btn-success:hover,\n.btn-success:focus,\n.btn-success:active,\n.btn-success.active,\n.open .dropdown-toggle.btn-success {\n  background-color: var(--primarycolor);\n  border-color: var( --btnbordercolor);\n  color: #FFFFFF;\n}\n\n.bg-success {\n  background-color: var( --)!important;\n}\n\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active,\n.btn-danger.active,\n.open .dropdown-toggle.btn-danger {\n  background-color: #ff9700;\n  border-color: #ff9700;\n  color: #FFFFFF;\n}\n\na.btn-xs {\n  margin: 2px 2px;\n}\n\n.btn-xs {\n  padding: 3px 7px;\n  font-size: 12px!important;\n  font-weight: 400;\n  text-align: center;\n  margin: 2px;\n}\n.btn-xs:hover{\n  background: var(--btn-hover-color) !important;\n}\n.adv-table .dataTables_length select{\n      padding: 5px 0 !important;\n}\n\n.ban-head-new {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: var( --secondary-color);\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-group-lg>.btn, .btn-lg {\n  padding: 10px 16px;\n  margin-top: 20px;\n  font-size: 18px;\n  line-height: 1.3333333;\n  border-radius: 6px;\n}\n\n.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {\n  position: relative;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.col-lg-12 {\n  padding: 5px 15px;\n}\n\n.btnRefresh {\n  width: 40px;\n  height: 40px;\n  color: #fff !important;\n  background-image: linear-gradient(315deg, #b80000 0%, #000000 74%);\n  border: none;\n  border-radius: 50%;\n  color: white;\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.btnRefresh:hover {\n  background-color: #0056b3;\n}\n\n.btnRefresh:before {\n  content: '\\21BB'; /* Unicode for refresh icon */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
